import { ApplyViaType } from '../stories/organisms/CompanyForm/CompanyContact/CompanyContact'
import { RemoteWork } from '../service/util/master-data/masterdata'
import { OptionOrString } from '../stories/atoms/SelectOrFreeTextMenu/SelectOrFreeTextMenu'

export enum JobType {
  UNKNOWN_JOB_TYPE = 0,
  SINGLE_STEP = 1,
  MULTI_STEP = 2,
}

export type DuplicateJobResponse = {
  id: string
  jobType: JobType
}

export type JobCriteriaForm = {
  branches: string[]
  contractTypes: string[]
  educationLevels: string[]
  experienceLevel: string
  functionGroups: string[]
  functionGroup: OptionOrString
  hours: {
    min: string
    max: string
  }
  place: {
    value?: string
    label?: string
  }
  title: string
  salary: {
    min: string
    max: string
  }
  typedSalary: {
    min: number | undefined
    max: number | undefined
    type: SalaryType
  }
  remoteWork: RemoteWork | ''
}

export type JobDescriptionForm = {
  corporateIdentityTemplate?: string
  jobText: string
  videoUrl?: string
}

export type JobCompanyForm = {
  address: string
  applyVia: ApplyViaType
  applyViaEmail: string
  applyViaFirstName: string
  applyViaLastName: string
  applyViaWebsite: string
  city: string
  company: string
  email?: string
  firstName?: string
  lastName?: string
  logo: string
  phoneNumber?: string
  website?: string
  zipCode: string
}

export type JobPromotionForm = {
  iscoId: string
  functionName: string
  costPerConversion: number
}

export type VacancyPublicationDate = {
  publicationDate: {
    startDate: string
    endDate: string
  }
}

export type PerformanceBasedJobSubmitRequestData = {
  jobId: string
  conversions: number
}

export type SingleStepJobForm = JobCriteriaForm &
  JobDescriptionForm &
  JobCompanyForm &
  VacancyPublicationDate

// If you update this enum, be sure to update its counterpart in:
// frontend/src/stories/molecules/SalaryRangeInput/SalaryRangeInput.tsx
export enum SalaryType {
  NoType = 'NoType',
  PerHour = 'PerHour',
  PerMonth = 'PerMonth',
  PerYear = 'PerYear',
}

// If you update this type, be sure to update its counterpart in:
// frontend/src/stories/molecules/SalaryRangeInput/SalaryRangeInput.tsx
export type TypedSalary = {
  min: number
  max: number
  type: SalaryType
}
